import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { resolvePath } from 'Utils/resolvePath';
import { replaceFieldsWithValues } from '../replaceFieldsWithValues';
import { DeviceContext } from '@/pages/_app';
import ViewMore from '../ViewMore';

const ManualContent = ({
    manualdata,
    location,
    brand,
    nearYou,
    city,
    garage,
}: {
    manualdata: any;
    location: any;
    brand: any;
    nearYou: any;
    city: any;
    garage: any;
}) => {
    const { heading, topContent = '', collapsables = [] } = manualdata;

    const [activeIndex, setActiveIndex] = useState(
        new Array(collapsables?.length).fill(true)
    );

    const isRobot = useContext(DeviceContext).isRobot;
    const DataWrapperRef = useRef<HTMLDivElement>(null);

    const [shouldRenderViewMore, setShouldRenderViewMore] = useState(false);
    const [shouldRenderViewLess, setShouldRenderViewLess] = useState(false);

    const [showFullData, setShowFullData] = useState(true);

    useEffect(() => {
        if (!isRobot) {
            setShowFullData(false);
            setActiveIndex(new Array(collapsables?.length).fill(false));
        }
        return () => {
            setShowFullData(false);
        };
    }, []);

    const toggleCollapsible = (index: number) => {
        setActiveIndex((prevState) => {
            const newState = [...prevState];

            newState[index] = !newState[index];
            if (newState[index]) {
                newState.forEach((_, i) => {
                    if (i !== index) newState[i] = false;
                });
            }

            return newState;
        });
    };

    useEffect(() => {
        if (DataWrapperRef.current) {
            let renderMore =
                DataWrapperRef.current.scrollHeight >
                DataWrapperRef.current.clientHeight;
            setShouldRenderViewMore(renderMore);
        }
    }, [showFullData]);

    return (
        <ManualContentWrapper>
            {heading && (
                <ManualContentHeading>
                    {replaceFieldsWithValues(heading, {
                        location,
                        brand,
                        nearYou,
                        city,
                        garage,
                    })}
                </ManualContentHeading>
            )}
            <DataWrapper ref={DataWrapperRef} showFullData={showFullData}>
                {topContent && (
                    <ManualTopContent
                        dangerouslySetInnerHTML={{
                            __html: replaceFieldsWithValues(topContent, {
                                location,
                                brand,
                                nearYou,
                                city,
                                garage,
                            }),
                        }}
                    />
                )}
            </DataWrapper>
            {/* {collapsables &&
                    collapsables.map((collapsable: any, index: number) => {
                        return (
                            <CollapsibleQAContainer key={index}>
                                <CollapsibleQuestionWrapper
                                    onClick={() => toggleCollapsible(index)}
                                >
                                    <CollapsibleQuestion>
                                        {replaceFieldsWithValues(
                                            collapsable.text,
                                            {
                                                location,
                                                brand,
                                                nearYou,
                                                city,
                                                garage,
                                            }
                                        )}
                                    </CollapsibleQuestion>
                                    <Image
                                        src={
                                            activeIndex[index]
                                                ? resolvePath(
                                                      '/images/seo/Minus.svg'
                                                  )
                                                : resolvePath(
                                                      '/images/seo/Plus.svg'
                                                  )
                                        }
                                        width={14}
                                        height={14}
                                    />
                                </CollapsibleQuestionWrapper>
                                {activeIndex[index] && (
                                    <CollapsibleAnswer
                                        dangerouslySetInnerHTML={{
                                            __html: replaceFieldsWithValues(
                                                collapsable.subText,
                                                {
                                                    location,
                                                    brand,
                                                    nearYou,
                                                    city,
                                                    garage,
                                                }
                                            ),
                                        }}
                                    />
                                )}
                            </CollapsibleQAContainer>
                        );
                    })} */}
            {shouldRenderViewMore && (
                <ViewMoreWrapper>
                    <ViewMore
                        handleViewMoreClick={() => {
                            setShouldRenderViewMore(false);
                            setShouldRenderViewLess(true);
                            setShowFullData(true);
                        }}
                        text="Read more"
                    />
                </ViewMoreWrapper>
            )}
            {shouldRenderViewLess && !shouldRenderViewMore && (
                <ViewMoreWrapper>
                    <ViewMore
                        handleViewMoreClick={() => {
                            setShouldRenderViewMore(true);
                            setShouldRenderViewLess(false);
                            setShowFullData(false);
                        }}
                        text="Read less"
                    />
                </ViewMoreWrapper>
            )}
        </ManualContentWrapper>
    );
};

export default ManualContent;

const ManualContentWrapper = styled.div`
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    gap: 20px;
    background: #fff;
`;

const ManualContentHeading = styled.h2`
    color: #121212;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
    margin: 0;
    align-self: stretch;
`;

const ManualTopContent = styled.div`
    > p {
        color: #4b4b4b;
        font-family: 'Euclid Circular B', 'Inter', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin: 0;
    }
    > p,
    ol {
        margin: 0;
    }
`;

const CollapsibleQAContainer = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: 12px;
    background: #f5f3f9;
`;

const CollapsibleQuestionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;

const CollapsibleQuestion = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    max-width: calc(100% - 24px);
`;

const CollapsibleAnswer = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    align-self: stretch;
    > p,
    ol {
        margin: 0;
    }
`;

export const ViewMoreWrapper = styled.div`
    padding-top: 8px;
`;

export const DataWrapper = styled.div<{
    showFullData: boolean;
}>`
    flex-direction: column;
    gap: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: ${({ showFullData }) => (showFullData ? 'visible' : 'hidden')};
    text-overflow: ${({ showFullData }) =>
        showFullData ? 'unset' : 'ellipsis'};
    -webkit-line-clamp: ${({ showFullData }) => (showFullData ? 'unset' : '2')};
`;
